window.makeModel = null;
(async function () {
  // start the vehicle list request right away, the make select spins until it arrives
  PCVehicleData.setSelectLoading(
    document.querySelector(".refurbished-selection select[data-for='make']"),
    true
  );
  const vehicleList = PCVehicleData.load();
  const directButton = document.querySelector(".refurbished-direct-button");
  const atcButton = document.querySelector(".refurbished-atc-button");
  const recommendedVariants = await getUsableVariants();
  const recommendationDivider = document.querySelector(".refurbished-divider");
  const recommendationDescription = document.querySelector(
    ".refurbished-brands-description"
  );
  const recommendationContainer = document.querySelector(".refurbished-brands");
  const recommendationBrandTemplate = document.querySelector(
    ".refurbished-brands .brand[data-template]"
  );
  const recommendationBrandTitleTemplate = document.querySelector(
    ".refurbished-brands .brand-title[data-template]"
  );
  const recommendationVarintsWrapperTemplate = document.querySelector(
    ".refurbished-brands .models-wrapper"
  );
  const recommendationVariantTemplate = document.querySelector(
    ".refurbished-brands .model[data-template]"
  );

  const makeSelect = document.querySelector(
    ".refurbished-selection select[data-for='make']"
  );
  const modelSelect = document.querySelector(
    ".refurbished-selection select[data-for='model']"
  );
  const yearSelect = document.querySelector(
    ".refurbished-selection select[data-for='year']"
  );
  const engineSelect = document.querySelector(
    ".refurbished-selection select[data-for='engine']"
  );

  makeSelect.addEventListener("change", handleMakeSelectChange);
  modelSelect.addEventListener("change", handleModelSelectChange);
  yearSelect.addEventListener("change", handleYearSelectChange);
  engineSelect.addEventListener("change", handleEngineSelectChange);

  const refurbishedBannerContainer = document.querySelector(
    ".refurbished-banner"
  );
  // Vehicle list of the visitor's market (assets/pc-vehicle-data.js)
  window.makeModel = await vehicleList.catch((error) => {
    console.error("Failed to fetch data", error);
    return [];
  });
  PCVehicleData.setSelectLoading(makeSelect, false);

  const brands = makeModel.map((item) => item.make);

  populateSelectBox({ select: makeSelect, data: brands });

  // items: strings, or { label, value } (models: value is the product handle)
  function populateSelectBox({ select, data }) {
    select.disabled = false;
    data.forEach((item) => {
      const option = document.createElement("option");
      option.innerText = typeof item === "string" ? item : item.label;
      option.value = typeof item === "string" ? item.toLowerCase().replaceAll(" ", "-") : item.value;
      select.appendChild(option);
    });
  }

  let currentlySelectedModelInfo = null;
  let selectedRefurbishedPc = null;
  let selectedModelsVariants = null;
  function handleMakeSelectChange() {
    resetSelectBoxes("make");
    const selected = this[this.selectedIndex];
    const models = makeModel.find((item) => {
      return item.make === selected.innerText;
    })?.models;

    if (!models) return;
    populateSelectBox({
      select: modelSelect,
      data: models.map((m) => ({ label: m.model, value: m.handle })),
    });
  }

  function handleModelSelectChange() {
    resetSelectBoxes("model");
    const model = modelSelect[modelSelect.selectedIndex].value;
    const targetProductLink = `${PCVehicleData.productUrl(model)}.json`;
    const yearsAndEngines = {};

    fetch(targetProductLink, {})
      .then((res) => res.json())
      .then(async (data) => {
        const {
          product: { variants },
        } = data;
        selectedModelsVariants = variants;
        const yearsAndEngines = {};
        variants.forEach((variant, i) => {
          const parsed = variant.title.split("/");
          const [pcCode, make, model, year, engine] = parsed.map((item) =>
            item.trim()
          );

          const engines = engine
            .replaceAll("(", " ")
            .replaceAll(")", " ")
            .split("-")
            .map((item) => item.trim());
          yearsAndEngines[year] = { pcCode, engines };
        });
        const years = Object.keys(yearsAndEngines);
        populateSelectBox({ select: yearSelect, data: years });
        currentlySelectedModelInfo = yearsAndEngines;
      });
  }

  function handleYearSelectChange() {
    resetSelectBoxes("year");
    const selectedOption = this[this.selectedIndex].innerText;
selectedRefurbishedPc = refurbishedVariants.find((item) => {
      const pcCode = currentlySelectedModelInfo[selectedOption].pcCode;
      const regex = /PC\d+/;
      const match = pcCode.match(regex);
      if (match) {
        const extractedCode = match[0];
        return new RegExp(extractedCode + "(?!\\d)").test(item.title);
      }
      return false;
    });

    const { engines } = currentlySelectedModelInfo[selectedOption];
    populateSelectBox({ select: engineSelect, data: engines });
  }

  function handleEngineSelectChange() {
    // console.log("selectedRefurbishedPc--->",selectedRefurbishedPc)
    // if (!selectedRefurbishedPc) throw new Error("no selected pc");
    // const isRefurbishedAvailable = selectedRefurbishedPc?.available;
    const isRefurbishedAvailable = selectedRefurbishedPc?.available ?? false;

    const model = `${makeSelect[makeSelect.selectedIndex].innerText} ${modelSelect[modelSelect.selectedIndex].innerText}`;
    const year = yearSelect[yearSelect.selectedIndex].innerText;
    const engine = engineSelect[engineSelect.selectedIndex].innerText;
    const selectedVariant = selectedModelsVariants.find((variant) => {
      return variant.title.includes(year);
    });
    showRecommendations();
    if (isRefurbishedAvailable) {
      atcButton.classList.add("visible");
      const atcText = atcButton.querySelector(".text");
      atcText.innerHTML = `${model} - ${year} - ${engine} | Buy Now`;
      atcButton.dataset.atc = selectedRefurbishedPc.id;
      atcButton.dataset.selection = selectedVariant.title;
    } else {
      const computedStyle = getComputedStyle(recommendationContainer);
      const headerHeight = parseFloat(
        computedStyle.getPropertyValue("--header-height")
      );
      window.scrollTo({
        top: recommendationContainer.offsetTop - headerHeight,
        behavior: "smooth",
      });
      const button = document.querySelector(".refurbished-direct-button");
      button.href = `/products/${model.replaceAll(" ", "-").toLowerCase()}`;
      directButton.classList.add("visible");
    }
  }

  function resetSelectBoxes(changed) {
    directButton.classList.remove("visible");
    atcButton.classList.remove("visible");
    removeSelectOptionsKeepFirst(engineSelect);
    engineSelect.disabled = true;
    if (changed === "year") return;

    removeSelectOptionsKeepFirst(yearSelect);
    yearSelect.disabled = true;
    currentlySelectedModelInfo = null;
    selectedModelsVariants = null;
    if (changed === "model") return;

    removeSelectOptionsKeepFirst(modelSelect);
    modelSelect.disabled = true;
  }

  function removeSelectOptionsKeepFirst(select) {
    const length = select.options.length;
    for (let i = length - 1; i > 0; i--) {
      select.remove(i);
    }
  }

  async function fetchAllProducts() {
    const SHOPIFY_STORE_URL = "/api/2025-07/graphql";
    const ACCESS_TOKEN = "960b68e3d27e55870e9ad333d5a199a1";
    const allProducts = [];

    let hasNextPage = true;
    let endCursor = null;

    while (hasNextPage) {
      const query = `
      {
        products(first: 250, after: ${
          endCursor ? `"${endCursor}"` : null
        }, query: "title:'Pedal Commander for'") {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              variants(first: 250) {
                edges {
                  node {
                    id
                    title
                  }
                }
              }
            }
          }
        }
      }
    `;

      try {
        const response = await fetch(SHOPIFY_STORE_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
          },
          body: JSON.stringify({ query }),
        });

        const data = await response.json();

        const products = data.data.products.edges;
        const pageInfo = data.data.products.pageInfo;

        allProducts.push(...products);

        hasNextPage = pageInfo.hasNextPage;
        endCursor = pageInfo.endCursor;
      } catch (error) {
        console.error("Error fetching data:", error);
        hasNextPage = false; // Exit loop on error
      }
    }
    return allProducts;
  }

  async function getUsableVariants() {
    const rawProducts = await fetchAllProducts();

    const availableUnits = refurbishedVariants.filter((unit) => unit.available);
    const availablePcCodes = availableUnits.map((unit) => {
      return extractPcCodeFromString(unit.title);
    });
    const availableVariants = {};
    rawProducts.forEach((item) => {
      const variants = item.node.variants.edges;
      variants.forEach((variant) => {
        const { title, id } = variant.node;
const isIncludePcCode = new RegExp(
          "(" + availablePcCodes.join("|") + ")(?!\\d)"
        ).test(title);
        if (isIncludePcCode && !title.includes("Refurbished")) {
          const [pcCode, make, model, year, engine] = title
            .split("/")
            .map((item) => item.trim());
          const obj = { pcCode, make, model, year, engine };
          const finalIdParts = id.split("/");
          const finalId = finalIdParts[finalIdParts.length - 1];
          if (availableVariants[make]) {
            availableVariants[make].push({ title, id: finalId });
          } else {
            availableVariants[make] = [{ title, id: finalId }];
          }
        }
      });
    });
    return availableVariants;
  }

  function extractPcCodeFromString(title) {
    const regex = /PC\d+/;
    const match = title.match(regex);
    if (match) return match[0];
    return null;
  }

  recommendationBrandTemplate.innerHTML = "";
  recommendationContainer.innerHTML = "";
  recommendationVarintsWrapperTemplate.innerHTML = "";

  Object.entries(recommendedVariants)
    .sort()
    .forEach(([make, variants], i) => {
      const brandCloned = recommendationBrandTemplate.cloneNode(true);
      const modelsWrapperCloned =
        recommendationVarintsWrapperTemplate.cloneNode(true);
      const brandTitleCloned = recommendationBrandTitleTemplate.cloneNode(true);
      brandTitleCloned.innerText = make;
      brandTitleCloned.onclick = openModels;
      brandCloned.append(brandTitleCloned);
      brandCloned.append(modelsWrapperCloned);

      variants
        .sort((a, b) => {})
        .forEach((variant) => {
          const [pcCode, make, model, year, engine] = variant.title
            .split("/")
            .map((item) => item.trim());
          const variantCloned = recommendationVariantTemplate.cloneNode(true);
          const textNode = variantCloned.querySelector(".text");
          textNode.innerText = `${model} ${year} ${engine}`;

          variantCloned.dataset.pcCode = pcCode;
          variantCloned.dataset.make = make;
          variantCloned.dataset.model = model;
          variantCloned.dataset.year = year;
          variantCloned.dataset.engine = engine;
          variantCloned.dataset.selection = variant.title;
          variantCloned.dataset.variantId = variant.id;
          variantCloned.onclick = handleVariantClick;
          modelsWrapperCloned.append(variantCloned);
        });
      recommendationContainer.append(brandCloned);
    });

  function showRecommendations() {
    recommendationContainer.classList.remove("hidden");
    recommendationDivider.classList.remove("hidden");
    recommendationDescription.classList.remove("hidden");
  }
  function openModels() {
    const clickedModelsHeight = this.nextElementSibling.style.height;
    const openedModel = document.querySelector(
      ".refurbished-brands .models-wrapper:not(.collapsed)"
    );

    if (openedModel) {
      openedModel.style.height = `${openedModel.scrollHeight}px`;
      requestAnimationFrame(() => {
        openedModel.classList.add("collapsed");
        openedModel.style.height = "0";
      });
    }

    if (!(clickedModelsHeight === "" || clickedModelsHeight == "0px")) return;
    const targetModel = this.nextElementSibling;
    targetModel.classList.remove("collapsed");
    targetModel.style.height = "auto";
    const height = targetModel.scrollHeight;
    targetModel.style.height = "0";

    requestAnimationFrame(() => {
      targetModel.style.height = `${height}px`;
    });
  }

  function handleVariantClick() {
    const atcButton_2 = document.querySelector(".refurbished_atc_2");
    const { variantId, selection, pcCode } = this.dataset;
const selectedRefurbishedPc = refurbishedVariants.find((item) => {
      const regex = /PC\d+/;
      const match = pcCode.match(regex);
      if (match) {
        const extractedCode = match[0];
        return new RegExp(extractedCode + "(?!\\d)").test(item.title);
      }
      return false;
    });
    const atcIcon = this.querySelector(".cart-icon");
    const loaderIcon = this.querySelector(".loader-icon");
    atcIcon.classList.add("hidden");
    loaderIcon.classList.add("visible");
    const animationInterval = setInterval(() => {
      const overlay = document.querySelector("custom-cart-drawer");
      if (overlay?.style.visiblity === "hidden") return;
      clearInterval(animationInterval);
      setTimeout(() => {
        //WRAPPED IN SETTIMEOUT IN ORDER TO WAIT FOR DRAWER ANIMATION DURATION
        atcIcon.classList.remove("hidden");
        loaderIcon.classList.remove("visible");
      }, 1000);
    }, 250);
    atcButton.dataset.atc = selectedRefurbishedPc.id;
    atcButton.dataset.selection = selection;
    atcButton.click();
  }
})();
